import { IStudent } from 'Src/ng2/shared/typings/interfaces/student.interface';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ISubscription } from 'rxjs/Subscription';
import { IAssignSupportModalComponentData } from 'src/ng2/shared/modals/assign-support/assign-support-modal.component';
import { ISchoolSupport } from 'Src/ng2/shared/typings/interfaces/support.interface';
import { AssignSupportModalService } from './../../../shared/modals/assign-support/assign-support-modal.service';
import { ModalsService } from './../../../shared/modals/modals.service';
import { UserRolePermissionsForModelService } from './../../../shared/services/user-role-permissions-for-model/user-role-permissions-for-model.service';

@Component({
  selector: 'ssv-side-nav-secondary',
  template: require('./ssv-side-nav-secondary.component.html'),
  styles: [require('./ssv-side-nav-secondary.component.scss')],
})
export class SsvSideNavSecondary implements OnInit {
  student: IStudent;
  isNoteRestricted: boolean;
  isStudentSupportRestricted: boolean;
  disableAddNoteBtn: boolean;
  disableAssignSupportBtn: boolean;
  showPanelSelectionList: boolean;
  isStudentSupportsRestricted: boolean;
  isGenerateReportRestricted: boolean;

  @Input() currentUser: any;
  @Input() currentStudent: any;
  @Input() currentSchool: any;
  @Input() isSummerSchoolStudent: boolean;
  @Output() noteCreatedEvent: EventEmitter<any> = new EventEmitter();
  @Output() studentSupportCreatedEvent: EventEmitter<any> = new EventEmitter();
  @Output() collapsedPanelsUpdatedEvent: EventEmitter<any> = new EventEmitter();

  openAssignSupportsModalSubscription: ISubscription;

  constructor(
    @Inject('NoteModal') private NoteModal: any,
    @Inject('Rollbar') private Rollbar,
    private userRolePermissionsForModelService: UserRolePermissionsForModelService,
    private assignSupportModalService: AssignSupportModalService,
    private modalsService: ModalsService,
  ) {}

  public ngOnInit(): void {
    this.showPanelSelectionList = false;
    this._setPermissioning();
  }

  _setPermissioning() {
    const NOTE_PERMISSIONING_MODEL_NAME = 'NOTE';
    const STUDENT_SUPPORTS_PERMISSIONING_MODEL_NAME = 'STUDENT_SUPPORT';

    const canCreateNote = this.userRolePermissionsForModelService.canCreatePartial(NOTE_PERMISSIONING_MODEL_NAME);
    const canCreateStudentSupport = this.userRolePermissionsForModelService.canCreatePartial(
      STUDENT_SUPPORTS_PERMISSIONING_MODEL_NAME as any,
    );
    const obj = null; // we are not checking permissioning for an instance, but for the MODEL as a whole

    this.isGenerateReportRestricted = this.isSummerSchoolStudent;
    this.isNoteRestricted = this.isSummerSchoolStudent || !canCreateNote(obj, this.currentUser);
    this.isStudentSupportsRestricted = this.isSummerSchoolStudent || !canCreateStudentSupport(obj, this.currentUser);
  }

  togglePanelSelectionList(): void {
    this.showPanelSelectionList = !this.showPanelSelectionList;
  }

  printCurrentStudent(): void {
    const data = { studentIds: [this.currentStudent._id], isProfileMode: true };
    this.modalsService.openStudentReportModal(data);
  }

  public updatePanels($event) {
    this.collapsedPanelsUpdatedEvent.emit($event);
  }

  /* istanbul ignore next */
  addNote(): void {
    const opts = {
      schoolId: this.currentStudent.schoolId,
      studentId: this.currentStudent._id,
      currentUser: this.currentUser,
    };
    this.disableAddNoteBtn = true;

    this.NoteModal.show(opts)
      .then(result => {
        this.disableAddNoteBtn = false;
        if (result && result.action === 'ADD_NOTE') {
          this.noteCreatedEvent.emit(result.note);
        }
      })
      .catch(err => {
        this.disableAddNoteBtn = false;
        const msg = `Unable to add note for student: ${this.currentStudent._id}`;
        this.Rollbar.warn(msg, err);
      });
  }

  /* istanbul ignore next */
  addSupport(): void {
    const { _id: studentId } = this.currentStudent;
    const { _id: schoolId } = this.currentSchool;
    this.disableAssignSupportBtn = true;

    const data: IAssignSupportModalComponentData = {
      schoolId,
      studentIds: [studentId],
      isProfileMode: true,
    };

    this.openAssignSupportsModalSubscription = this.modalsService
      .openAssignSupportModal(data)
      .afterClosed()
      .subscribe((selectedSupport: ISchoolSupport) => {
        // If !selectedSupport, then the user canceled action in modal (CM).
        this.disableAssignSupportBtn = false;
        if (selectedSupport) {
          const payload = {
            support: selectedSupport,
            studentId,
            schoolId,
          };
          this.assignSupportModalService.createStudentSupport(payload);
        }
      });
  }
}
